// Mirrors GolfPlayed.Domain.Helpers.Constants.MemberTypeConstants on the backend.
// Lifetime is a seeded, permanent MemberType (full access, no payment ever required - friends &
// family, admin/staff accounts), so its id is fixed here rather than looked up by name.
// Free is the seeded tier every public sign-up lands on.

export const MemberTypeConstants = {
  LIFETIME_ID: 'a1b2c3d4-9999-4e5f-8a9b-0c1d2e3f4a5b',
  FREE_ID: 'f9e8d7c6-1111-4a2b-9c3d-4e5f6a7b8c9d',
};

// Mirrors GolfPlayed.Domain.Helpers.Constants.MembershipConstants.FreeCoursesPlayedLimit.
//
// Used only to stop a doomed request and offer the upgrade a moment sooner. It is not the rule:
// MemberCoursesPlayedFunction enforces the real one and refuses the 31st course with a 403, and
// that stays true however stale, patched or bypassed this number gets in a browser.
export const FREE_COURSES_PLAYED_LIMIT = 30;

// Mirrors MembershipConstants.IsCoursesPlayedCapped on the backend. A free member, or any member
// who has not paid (a lapsed subscription, a migrated legacy member), is held to the limit above.
// Lifetime never is. GUIDs compared lower-cased, per CLAUDE.md.
export const isCoursesPlayedCapped = (
  memberTypeId: string | null | undefined,
  active: boolean | null | undefined,
): boolean => {
  const typeId = memberTypeId?.toLowerCase();
  if (typeId === MemberTypeConstants.LIFETIME_ID) {
    return false;
  }
  return typeId === MemberTypeConstants.FREE_ID || active !== true;
};
